export class LoginForm {
    /** @type {string} */
    username = '';

    /** @type {string} */
    password = '';
}